import React from 'react';
import { Cancel, CheckCircle } from '@mui/icons-material';
import { Grid, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';

interface PasswordRequirementsProps {
  requirements: string[];
  password: string;
}

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ requirements, password }) => {
  const checkRequirement = (requirement: string): boolean => {
    switch (requirement) {
      case 'At least 8 characters':
        return password.length >= 8;
      default:
        return false;
    }
  };

  return (
    <div>
      <Typography gutterBottom>Password Requirements:</Typography>
      <Grid container spacing={1}>
        {requirements.map((req, index) => (
          <Grid item xs={6} key={index} container alignItems="center">
            <Grid item>{checkRequirement(req) ? <CheckCircle color="success" /> : <Cancel color="error" />}</Grid>
            <Grid item>
              <Typography style={{ marginLeft: 8 }}>{req}</Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default PasswordRequirements;

